import React from 'react';
import { getRoleConfig } from '../data/RoleConfig';
import { renderWidget } from './widgets/ClientWidgets';

const OverviewTab = ({ client, journeyStage, currentStageIndex, liveStages, userRole, loggedInAgent, onForceProvision, onUpdateClient }) => {
    const roleConfig = getRoleConfig(userRole || 'Sales_L1');
    const widgetList = roleConfig.profileLayout || [];

    return (
        <div className="animate-fade-in">
            <div className="mb-6 flex justify-between items-end">
                <div>
                    <h3 className="text-xl font-bold text-white">Client Overview</h3>
                    <p className="text-slate-400 text-sm">
                        View Mode: <span className="text-blue-400 font-bold">{roleConfig.label}</span>
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-20">
                {widgetList.length > 0 ? (
                    widgetList.map(widgetId => renderWidget(widgetId, client, userRole, loggedInAgent, liveStages, onForceProvision, onUpdateClient))
                ) : (
                    <div className="col-span-3 text-center py-12 border border-dashed border-slate-700 rounded-xl text-slate-500">
                        No widgets configured for this role.
                    </div>
                )}
            </div>
        </div>
    );
};

export default OverviewTab;